import { EnrollmentSummary } from './enrollment-summary.model';

export interface VehicleEnrollment {
  vehicleMake: string;
  vehicleModel: string;
  vehicleYear: string;
  vin: string;
  enrollmentSummary?: EnrollmentSummary;
}
